import { useEffect } from "react";
import { useIntercom } from "react-use-intercom";

const useControlIntercom = (hidden = true) => {
  const { update } = useIntercom();

  useEffect(() => {
    if (!hidden) {
      return;
    }

    update({ hideDefaultLauncher: true });

    return () => {
      update({ hideDefaultLauncher: false });
    };
  }, [hidden, update]);
};

export default useControlIntercom;
